var map = {
	"./linkCheck/linkCheck.js": 231,
	"./plugin-config.js": 834,
	"./pluginsSpace.js": 833,
	"./securityPlugin/securityPlugin.js": 1487,
	"./storyImport/components/resourceImport.js": 835,
	"./storyImport/storyImport.js": 1494,
	"./storyLayout/addSpecialClass.js": 821,
	"./storyLayout/addStartAndEnd.js": 822,
	"./storyLayout/removeLabelStyle.js": 823,
	"./storyLayout/removeStyleAndPoint.js": 824,
	"./storyLayout/storyLayout.js": 825,
	"./storyResource/storyResource.js": 1495,
	"./taskPicture/taskPicture.js": 829,
	"./taskVideo/taskVideo.js": 832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4724;